module.exports = __webpack_public_path__ + "static/media/Togaf.fdf253da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lives/Togaf.png
// module id = 307
// module chunks = 0